import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Process } from "./components/Process";
import { References } from "./components/References";
import { Instagram } from "./components/Instagram";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Gallery } from "./components/Gallery";
import { Datenschutz } from "./components/Datenschutz";
import { Impressum } from "./components/Impressum";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <About />
    <Services />
    <Process />
    <References />
    <Instagram />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="App bg-gray-950">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/galerie" element={<Gallery />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
        <WhatsAppButton />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
